export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/index.59b67b22.worker.js");
}
